module.exports = __webpack_public_path__ + "img/icon-recharge.122f1ac0.png";